import { BillsTableColumnKey } from '../types/billsTableColumnKey'

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const billsTableColumnHeaderLocaleKeys: Record<BillsTableColumnKey, string> = {
  actions: 'Actions',
  hasAttachments: 'Attachments',
  amountTotal: 'Incl. VAT',
  description: 'Description',
  dueDate: 'Due date',
  reference: 'Reference',
  receiptDate: 'Date',
  supplier: 'Supplier',
  type: 'Type',
  syncStatusIcon: 'Sync status',
  syncStatus: 'Status',
  eInvoiceStatus: 'Status',
  billStatus: 'Status',
}
